import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CameraInput} from "../../../modules/models/types";

@Component({
  selector: 'app-camera-input',
  templateUrl: './camera-input.component.html',
  styleUrls: ['./camera-input.component.css']
})
export class CameraInputComponent implements OnInit {
  public device: MediaDeviceInfo;
  public devices: MediaDeviceInfo[] = [];
  constructor(public dialogRef: MatDialogRef<CameraInputComponent>, public detectChange: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) public dialog_data: CameraInput) {
    dialog_data.devices.forEach((d) => {
      this.devices.push(d);
    })
  }

  ngOnInit(): void {
    this.device = this.devices[0];
  }

  close() {
    this.dialogRef.close();
    if (this.dialog_data.onclose) {
      this.dialog_data.onclose(this.device);
    }
  }

  public objectComparisonFunction = function( option, value ) : boolean {
    return option.deviceId === value.deviceId;
  }

}
